import { connect } from 'react-redux'
import * as actions from '../../../actions'
import * as api from '../../../actions/api'
import TweetListDialog from '../components/TweetListDialog'

const mapStateToProps = (state) => {
  const { open, tweetList, page, rowsPerPage, deleteId, openConfirmDialog } = state.tweetListDialog
  return ({
    open,
    tweetList,
    page,
    rowsPerPage,
    deleteId,
    openConfirmDialog,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleClose: () => {
      dispatch(actions.tweetListDialog.close())
    },
    handleEnter: () => {
      dispatch(api.twitter.fetchGetScheduleTweetList())
    },
    handleExited: () => {
      dispatch(api.twitter.clearScheduleTweetList())
    },
    handleChangePage: (event, page) => {
      dispatch(actions.tweetListDialog.changedPage(page))
    },
    handleChangeRowsPerPage: (event) => {
      dispatch(actions.tweetListDialog.changedRowsPerPage(event.target.value))
    },
    handleDelete: (id) => () => {
      dispatch(actions.tweetListDialog.openConfirmDialog(id))
    },
    handleCloseConfirmDialog: () => {
      dispatch(actions.tweetListDialog.closeConfirmDialog())
    },
    closeConfirmDialog: () => {
      dispatch(actions.tweetListDialog.closeConfirmDialog())
    },
    fetchDeleteScheduleTweet: (deleteId) => {
      dispatch(api.twitter.fetchDeleteScheduleTweet(deleteId))
    },
  })
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { deleteId } = stateProps
  return ({
    ...stateProps,
    ...dispatchProps,
    handleOK: () => {
      dispatchProps.fetchDeleteScheduleTweet(deleteId)
      dispatchProps.closeConfirmDialog()
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(TweetListDialog)



// WEBPACK FOOTER //
// ./src/Parts/MenuAppBar/containers/TweetListDialog.js